import { Icon } from '../../ui';
import styles from './AccordionHeader.module.css';
import { Accordion as RadixAccordion } from 'radix-ui';

type AccordionHeaderProps = {
  title: string;
  subtitle: string;
  description: string;
};

export const AccordionHeader = ({ title, subtitle, description }: AccordionHeaderProps) => {
  return (
    <RadixAccordion.Header>
      <RadixAccordion.Trigger className={styles.accordionTrigger}>
        <div className={styles.accordionHeaderHeadingLayout}>
          <p className={styles.accordionHeadingSubtitle}>{subtitle}</p>
          <div className={styles.accordionHeadingDescriptionContainer}>
            <p className={styles.accordionHeadingTitle}>{title}</p>
            <p className={styles.accordionHeadingDescription}>{description}</p>
          </div>
        </div>

        <Icon className={styles.accordionHeaderIcon} iconName='accordionDown' />
      </RadixAccordion.Trigger>
    </RadixAccordion.Header>
  );
};
